import { render, staticRenderFns } from "./server.vue?vue&type=template&id=7c87dfdf"
import script from "./server.vue?vue&type=script&lang=js"
export * from "./server.vue?vue&type=script&lang=js"
import style0 from "./server.vue?vue&type=style&index=0&id=7c87dfdf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports